import React from "react";
import "../../../../Assets/css/staticPage.css";
import { Link } from "react-router-dom"
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import LocalizedLink from '../../../../Components/LocalizedLink'
const CertifiedDiamonds = () => {

  const { t } = useTranslation()
  return (
    <div className="CertifiedDiamonds_page">
      <div className="CertifiedDiamonds-banner">
        <img
          className="img-fluid"
          alt="banner"
          src={require("../../../../Assets/images/custom-design/certified-diamonds/banner.png")}
        />
        <div className="text-center CertifiedDiamonds-banner-txt">
          <h3>{t('certi_dia.findYour')}</h3>
          <p>{t('certi_dia.whyChoose')}</p>
        </div>
      </div>

      <div className="CertifiedDiamonds-2">
        <Container>
          <img
            className="img-fluid mb-4"
            alt="banner"
            src={require("../../../../Assets/images/custom-design/certified-diamonds/Diamantes-naturales.png")}
          />
        </Container>
        <div className="CertifiedDiamonds-box">
          <Container>
            <h3>
              {t('certi_dia.findPerfect')}
            </h3>
            <p>
              {t('certi_dia.weOnlyWork')}
            </p>
            <h4 style={{ fontWeight: "bold" }}>{t('certi_dia.weWantExpert')}</h4>
            <div style={{ marginTop: "30px" }}>
              <LocalizedLink to="/make-an-appointment" className="d-inline-block golden-btn mx-auto">{t('certi_dia.talkToManuel')}</LocalizedLink>
            </div>
          </Container>
        </div>
      </div>

      <div className="CertifiedDiamonds-3">
        <Container>
          <Row className="align-items-center">
            <Col md={6} xs={12}>
              <img
                className="img-fluid"
                alt="banner"
                src={require("../../../../Assets/images/custom-design/certified-diamonds/1.png")}
              />
            </Col>
            <Col md={6} xs={12}>
              <h4>{t('certi_dia.whyChooseCerti')}</h4>
              <p>
                {t('certi_dia.inTheWorld')}
              </p>
              <p>
                {t('certi_dia.aCertiDia')}
              </p>
              <p>
                {t('certi_dia.atSpinosa')}</p>
              <p>
                {t('certi_dia.whileOther')}
              </p>
              <p>
                {t('certi_dia.whenChooseAfrnd')}
              </p>
              <ul>
                <li>✔ {t('certi_dia.perfection')}</li>
                <li>✔ {t('certi_dia.security')}</li>
                <li>
                  ✔ {t('certi_dia.exclusivity')}
                </li>
                <li>
                  ✔ {t('certi_dia.discoverOur')}
                </li>
              </ul>
              <div style={{ marginTop: "30px" }}>
                <LocalizedLink to="/engagement-rings" className="d-inline-block golden-btn mx-auto">{t('certi_dia.shopNow')}</LocalizedLink>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="CertifiedDiamonds-banner">
        <Container fluid className="d-flex justify-content-center">
          <div className="position-relative">
            <img
              className="img-fluid"
              alt="banner"
              src={require("../../../../Assets/images/custom-design/certified-diamonds/2.png")}
            />
            <div className="text-center CertifiedDiamonds-banner-txt">
              <h3>
                {t('certi_dia.wantUnique')}
              </h3>
            </div>
          </div>
        </Container>
      </div>

      <div className="CertifiedDiamonds-3 text-center">
        <h3>{t('certi_dia.the4c')}</h3>
        <p className="pb-0 mb-0">
          {t('certi_dia.theValue')}
        </p>
      </div>

      <div className="CertifiedDiamonds-4">
        <Container>
          <Row className="justify-content-center align-items-center">
            <Col md={6} xs={12}>
              <img
                className="img-fluid pr-md-5"
                alt="banner"
                src={require("../../../../Assets/images/custom-design/certified-diamonds/3.png")}
              />
            </Col>
            <Col md={6} xs={12}>
              <h3>{t('certi_dia.cut')}</h3>
              <p>
                {t('certi_dia.theCut')}
              </p>
              <ul>
                <li>
                  ✔ {t('certi_dia.cutGrades')}
                </li>
                <li>
                  ✔ {t('certi_dia.thebestCut')}
                </li>
                <li>
                  ✔ {t('certi_dia.theroundBri')}
                </li>
              </ul>

              {/* <p>How to choose the best diamond cut?</p> */}
              {/* <p>
                Click the button on the right side of this page and talk
                directly with me.
              </p> */}
            </Col>
          </Row>
        </Container>
      </div>

      <div className="CertifiedDiamonds-5 text-center">
        <Container>
          <Row className="justify-content-center align-items-center">
            <Col md={12} xs={12}>
              <h3>{t('certi_dia.color')}</h3>
              <p>
                {t('certi_dia.theMost')}
              </p>
              <ul>
                <li>
                  ✔ {t('certi_dia.forDiamonds')}
                </li>
                <li>
                  ✔ {t('certi_dia.forDiamonds2')}
                </li>
                <li>
                  ✔ {t('certi_dia.theLessColor')}
                </li>
              </ul>

              <img
                className="img-fluid p-5 pb-0"
                alt="banner"
                src={require("../../../../Assets/images/custom-design/certified-diamonds/4.png")}
              />

              <h3>{t('certi_dia.clarity')}</h3>
              <p>
                {t('certi_dia.everyDia')}
              </p>
              <img
                className="img-fluid"
                alt="banner"
                src={require("../../../../Assets/images/custom-design/certified-diamonds/5.png")}
              />
            </Col>
          </Row>
        </Container>
      </div>

      <div className="CertifiedDiamonds-6">
        <Container>
          <h3>{t('certi_dia.caratWt')}</h3>
          <p>
            {t('certi_dia.theCarat')}
          </p>
          <p>
            {t('certi_dia.largerDia')}
          </p>
        </Container>
      </div>

      <div className="CertifiedDiamonds-7">
        <Container>
          <h3 className="text-center mb-5">{t('certi_dia.anExclusive')}</h3>
          <Row className="justify-content-center align-items-center">
            <Col md={6} xs={12}>
              <img
                className="img-fluid"
                alt="banner"
                src={require("../../../../Assets/images/custom-design/certified-diamonds/manuel.jpeg")}
              />
            </Col>
            <Col md={6} xs={12}>
              <h3>{t('certi_dia.theRingYou')}</h3>
              <p>
                {t('certi_dia.inManyJ')}
              </p>
              <p>
                {t('certi_dia.andIf')}
              </p>
              <h4>{t('certi_dia.atSpinosaDia')}</h4>
              <p>
                {t('certi_dia.weDesign')}
              </p>
              <p>
                {t('certi_dia.theResult')}
              </p>
              <ul>
                <li>
                  ✔ {t('certi_dia.customDesigned')}
                </li>
                <li>
                  ✔ {t('certi_dia.craftedInOur')}
                </li>
                <li>
                  ✔ {t('certi_dia.readtInDays')}
                </li>
                <li>
                  ✔ {t('certi_dia.fullTransparency')}
                </li>
              </ul>
              <h5 className="mb-3 mt-3" style={{ fontWeight: "bold" }}>{t('certi_dia.stillHaveOpts')}</h5>
              <div style={{ marginTop: "30px" }}>
                <LocalizedLink to="/make-an-appointment" className="d-inline-block golden-btn mx-auto">{t('certi_dia.bookAPvt')}</LocalizedLink>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="CertifiedDiamonds-8">
        <Container>
          <Row className="justify-content-center align-items-center">
            <Col md={6} xs={12}>
              <h3 className="mb-3">
                {t('certi_dia.buyUrRing')}
              </h3>
              <p>
                {t('certi_dia.areUonVac')}
              </p>
              <p>
                {t('certi_dia.ifUrVisiting')}
              </p>
            </Col>
            <Col md={6} xs={12}>
              <img
                className="img-fluid pr-md-5"
                alt="banner"
                src={require("../../../../Assets/images/custom-design/certified-diamonds/7.png")}
              />
            </Col>
          </Row>
        </Container>
      </div>

      <div className="CertifiedDiamonds-9">
        <Container>
          <Row>
            <Col md={6} xs={12}>
              <img
                className="img-fluid mb-3"
                alt="banner"
                src={require("../../../../Assets/images/custom-design/certified-diamonds/8.png")}
              />
              <h3>{t('certi_dia.cantVisit')}</h3>
              <p>
                {t('certi_dia.noProblem')}
              </p>
            </Col>
            <Col md={6} xs={12}>
              <img
                className="img-fluid mb-3"
                alt="banner"
                src={require("../../../../Assets/images/custom-design/certified-diamonds/9.png")}
              />
              <h3>{t('certi_dia.liveFar')}</h3>
              <p>
                {t('certi_dia.thatsAlsoPossible')}
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default CertifiedDiamonds;
